// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/**
  * GeneralMeta - General meta tag
  *
  * @example
    <GeneralMeta data={data} />
  *
  * @param {string} data.description - Required. Description of the webpage. Include a summary of the content on the webpage.
  * @param {string} data.keywords - Required. A set of words that describe the webpage. Minimum 3 words, maximum 10.
  * @param {string} data.image - Required. A unique banner image for the webpage.
  * 
  * @version 0.0.1
  * @todo none
  */
var GeneralMeta = function GeneralMeta(props) {
  var data = props.data;


  var sanitized = data.url;
  if (sanitized.endsWith("/")) {
    sanitized = sanitized.substring(0, sanitized.length - 1);
  }

  return React.createElement(Helmet, {
    meta: [
    // ---- General SEO
    { name: "description", content: data.description }, { name: "keywords", content: data.keywords }, { name: "image", content: data.image }, { name: "robots", content: "index,follow" }],
    link: [{ rel: "canonical", href: sanitized }]
  });
};

GeneralMeta.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.object // eslint-disable-line react/forbid-prop-types
} : {};

GeneralMeta.defaultProps = {
  data: {}
};

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Export
// ----------------------------------------------------------------------------
export default GeneralMeta;